import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { talukasListApi } from "Apis/member";

export const villageContext = createContext();

export const VillageContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [talukaList, setTalukaList] = useState([]);

  const getTalukaApi = async () => {
    let response = await talukasListApi();
    if (response?.status === 200) {
      setTalukaList(
        response.data.data.rows?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.name,
        }))
      );
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <villageContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        talukaList,
        setTalukaList,
        getTalukaApi,
      }}
    >
      {children}
    </villageContext.Provider>
  );
};

export default VillageContextProvider;
VillageContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
